import { type AxiosResponse } from 'axios'
import { type AxiosOptions } from 'shared/api'
import { baseApi } from 'entities/Auth'
import type {
  IParamsCreateSegment,
  IParamsGetSegmentsSearch,
  IParamsUpdateSegment,
  IResponseGetSegmentsSearch,
  IResponseSegment,
} from 'entities/Segment/api/types'

class Api {
  getSegments(options?: AxiosOptions): Promise<AxiosResponse<IResponseSegment[]>> {
    return baseApi.get('organization/segments', { ...options })
  }

  getSegmentsSearch(
    params: IParamsGetSegmentsSearch,
    options?: AxiosOptions
  ): Promise<AxiosResponse<IResponseGetSegmentsSearch>> {
    return baseApi.get('organization/segments/search', { ...options, params })
  }

  createItem(params: IParamsCreateSegment): Promise<AxiosResponse<IResponseSegment>> {
    return baseApi.post('organization/segments/create', params)
  }

  editItem(id: number, params: IParamsUpdateSegment): Promise<AxiosResponse<IResponseSegment>> {
    return baseApi.put(`organization/segments/${id}/update`, params)
  }

  deleteItem(id: number): Promise<AxiosResponse<boolean>> {
    return baseApi.delete(`organization/segments/${id}/delete`)
  }

  makeFavorite(id: number): Promise<AxiosResponse<IResponseSegment>> {
    return baseApi.post(`organization/segments/${id}/favorite`)
  }

  makeUnfavorite(id: number): Promise<AxiosResponse<IResponseSegment>> {
    return baseApi.delete(`organization/segments/${id}/favorite`)
  }
}

export const SegmentApi = new Api()
